import { getUserTable, deleteTable, userStatus } from '@/api/userManage';
import userModel from './userModel';
import standardTable from '@/components/standardTable/index';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const tableHead = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '管理员名称'
  },
  dataIndex: 'nickName',
  align: 'center'
}, {
  slots: {
    title: '角色'
  },
  dataIndex: 'roles',
  align: 'center'
}, {
  slots: {
    title: '手机号'
  },
  dataIndex: 'mobile',
  align: 'center'
}, {
  slots: {
    title: '状态'
  },
  dataIndex: 'status',
  align: 'center',
  scopedSlots: {
    customRender: 'status'
  }
},
// {
//   title: '创建日期',
//   dataIndex: 'date',
//   defaultSortOrder: 'ascend',align: 'center',
//   sorter: (a, b) => a.date > b.date,
//   ellipsis: true
// },

{
  slots: {
    title: '操作'
  },
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 140
}];
export default {
  name: 'userManage',
  components: {
    standardTable,
    userModel
  },
  filters: {
    statusFilter(status) {
      const statusList = {
        admin: '#f50',
        test: '#2db7f5',
        editor: '#87d068',
        custom: ''
      };
      return statusList[status];
    }
  },
  data() {
    return {
      name: '',
      status: undefined,
      loading: false,
      deleteLoading: false,
      exportLoading: false,
      tableData: [],
      selectedRowKeys: [],
      selectValue: [],
      dialogVisible: false,
      currentRow: null,
      tableHead,
      // pagination:{
      //     showSizeChanger: true,
      //     showQuickJumper: true,
      //     total:0,
      //     pageSize:10, // 每页条数
      //     page: 1,
      //     showTotal: ((total) => {
      //         return `${this.$t('共')} ${total} ${this.$t('条')}`;
      //     })
      // },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    changeRole(val) {
      this.status = val;
    },
    changeTime(str, time) {
      Object.assign(this.tableQuery, {
        startTime: time[0],
        endTime: time[1]
      });
    },
    getCheckboxProps: record => ({
      props: {
        disabled: record.role === 'admin',
        name: record.name
      }
    }),
    handleSelect(key, value) {
      this.selectedRowKeys = key;
      this.selectValue = value;
    },
    //查询
    handleSearch() {
      this.pagination.current = 1;
      this.getTableList();
    },
    //删除
    handleDelete(val) {
      deleteTable({
        userId: val.id
      }).then(() => {
        this.$message.success(this.$t('删除成功'));
        this.getTableList();
      });
    },
    //批量删除
    // handleBatchDelete() {
    //   if (this.selectValue.length == 0) {
    //     this.$message.warning('请至少勾选一项');
    //     return;
    //   }
    //   this.deleteLoading = true;
    //   const batchId = this.selectValue.map(item => item.id).join(',');
    //   batchDeleteTable({ batchId }).then(() => {
    //     this.$message.success('删除成功!');
    //     this.getTableList();
    //     this.deleteLoading = false;
    //   });
    // },
    //编辑
    handleEdit(row) {
      //这里还需要通过id获取用户对应的菜单，这里就不写了。
      this.currentRow = {
        ...row
      };
      this.dialogVisible = true;
    },
    //新增
    handleAdd() {
      this.currentRow = null;
      this.dialogVisible = true;
    },
    handleOk() {
      this.dialogVisible = false;
      this.currentRow = null;
      setTimeout(() => {
        this.getTableList();
      }, 400);
    },
    handleTableChange(val) {
      console.log(val, 555);
      this.pagination = val;
      this.getTableList();
    },
    //导出
    // handleExport() {
    //   this.exportLoading = true;
    //   import('@/vendor/Export2Excel').then(excel => {
    //     const header = [],
    //       filterVal = [];
    //     this.tableHead.forEach(item => {
    //       if (item.title != '操作' && item.title != '序号') {
    //         header.push(item.title);
    //         filterVal.push(item.dataIndex);
    //       }
    //     });
    //     const data = formatJson(this.tableData, filterVal);

    //     excel.export_json_to_excel({
    //       header,
    //       data,
    //       filename: '用户列表'
    //     });
    //     this.exportLoading = false;
    //   });
    // },
    //获取table数据
    getTableList() {
      this.loading = true;
      getUserTable({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.name,
        status: this.status
      }).then(res => {
        console.log(res);
        const data = res.items || [];
        this.pagination.total = res.totalNum;
        Object.assign(this, {
          tableData: data,
          loading: false
        });
      });
    },
    checkedFun(val) {
      if (!this.isAuth('home.userStatus')) {
        this.$message.error(this.$t('暂无操作权限'));
        return false;
      }
      userStatus({
        customerId: val.id,
        status: val.status == 0 ? 1 : 0,
        userId: val.id
      }).then(res => {
        this.$message.success(this.$t('操作成功'));
        val.status = val.status == 0 ? 1 : 0;
      });
    }
  }
};